/**
 * Normalizes dashboard `preferences` from the API: may be a JSON string or already an object.
 * Calling JSON.parse on an object coerces it to "[object Object]", which throws.
 *
 * @param {unknown} value - Raw `preferences` from API
 * @param {Record<string, unknown>} [defaultValue={}] - Fallback when missing/invalid
 * @returns {Record<string, unknown>}
 */
export function parsePreferencesField(value, defaultValue = {}) {
  if (value == null || value === "" || value === "undefined") {
    return defaultValue;
  }
  if (typeof value === "object" && value !== null && !Array.isArray(value)) {
    return value;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed || trimmed === "undefined") {
      return defaultValue;
    }
    try {
      const parsed = JSON.parse(trimmed);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return parsed;
      }
      return defaultValue;
    } catch {
      return defaultValue;
    }
  }
  return defaultValue;
}
